import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import {
  removeFromCompare,
  getCommonCounter,
  getUpdateQuantity,
  setHeaderCounters, // <-- import this
} from "../../actions";
import {
  getImageUrl,
  getPlaceHolderImage,
  getMasterDetailsIdUrl,
} from "../../services";
import { deleteCall, getCall, postCall } from "../../api/post";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  formatPrice,
} from "../../store";
import {
  isOpenStoreIdExist,
  clearLocalStorageReload,
  removeUserDetailAndOtherDetails,
  navigateTo,
} from "../../utils/utils";
import { checkAuthAndRedirect, getCurrentPath } from "../../utils/cartRedirect";
import ErrorMessageAnimationModal from "../../animation/ErrorMessageAnimationModal";
import AddToCartAnim from "../../animation/AddToCartAnim";
import DOMPurify from "dompurify";

// Add CSS for dynamic button sizing and skeleton loader
const buttonStyles = `
  .compare-dynamic-btn {
    display: block !important;
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    text-align: center !important;
    border-radius: 4px !important;
    font-weight: 500 !important;
    transition: all 0.3s ease !important;
    margin: 3px 0 !important;
    box-sizing: border-box !important;
    padding: 8px 12px !important;
    height: auto !important;
    line-height: 1.5 !important;
    border: none !important;
    outline: none !important;
  }
  .compare-btn-container {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .compare-btn-container td {
    padding: 5px !important;
  }
  .compare-remove-btn {
    background: #dc3545 !important;
    background-image: none !important;
    background-color: #dc3545 !important;
    border: 1px solid #dc3545 !important;
    color: white !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  .compare-remove-btn:hover,
  .compare-remove-btn:focus,
  .compare-remove-btn:active {
    background: #dc3545 !important;
    background-image: none !important;
    background-color: #dc3545 !important;
    border: 1px solid #dc3545 !important;
    color: white !important;
    box-shadow: none !important;
    text-shadow: none !important;
    transform: none !important;
  }
  .btn-solid {
    background: #ff6a00 !important;
    background-image: none !important;
    background-color: #ff6a00 !important;
    border: 1px solid #ff6a00 !important;
    color: white !important;
  }
  .btn-solid:hover {
    background: #2c3e50 !important;
    background-image: none !important;
    background-color: #2c3e50 !important;
    border: 1px solid #2c3e50 !important;
    color: #ffffff !important;
  }
  .skeleton-loader {
    background: #e0e0e0;
    border-radius: 4px;
  }
  .skeleton-image {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
  .skeleton-text {
    height: 16px;
    margin: 8px 0;
  }
  .skeleton-text.short {
    width: 60%;
  }
  .skeleton-text.medium {
    width: 80%;
  }
  .skeleton-text.long {
    width: 100%;
  }
  .skeleton-button {
    height: 35px;
    margin: 3px 0;
  }
  
  /* Remove extra space when compare list is empty */
  .compare-empty-container {
    height: calc(100vh - 350px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
  .compare-empty-message {
    text-align: center;
    padding: 20px;
  }
     .description-content {
    font-size: 14px;
    line-height: 1.6;
    color: #444;
    max-height: 220px;
    overflow-y: auto;
  }

  .description-content p {
    margin-bottom: 10px;
  }

  .description-content ul {
    padding-left: 18px;
    margin-bottom: 10px;
  }

  .description-content li {
    margin-bottom: 6px;
  }

  .description-content b,
  .description-content strong {
    font-weight: 600;
  }

  .description-content br {
    display: block;
    margin-bottom: 6px;
  }
`;

class Compare extends Component {
  state = {
    completeCompareItems: [],
    masterDetailsObj: {},
    loading: true,
    showErrorMessageModal: false,
    errorMessage: "",
    showAddToCartMessageModal: false,
    addToCartMessage: "",
  };

  componentDidMount() {
    this.initMasterDetailsId().then(() => {
      this.fetchComparisonData();
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.Items !== this.props.Items) {
      this.fetchCompleteProductData();
    }
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []);
    if (masterDetails.error) {
      console.error("Error fetching master details:", masterDetails.error);
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  fetchCompleteProductData = async () => {
    const { Items } = this.props;
    const compareItems = Items.slice(0, 4);

    if (compareItems.length === 0) {
      this.setState({ completeCompareItems: [], loading: false });
      return;
    }

    const completeItems = [];

    for (const item of compareItems) {
      // Check if the item already has productmedia
      if (item.productmedia && item.productmedia.length > 0) {
        completeItems.push(item);
      } else {
        // Fetch complete product data with productmedia
        try {
          const productUrl = `products/${item.id}?filter[include]=productmedia&filter[include]=category`;
          const productData = await getCall(productUrl, []);

          if (productData.error) {
            console.error("Error fetching product data:", productData.error);
            completeItems.push(item); // Use original item if fetch fails
          } else {
            completeItems.push(productData);
          }
        } catch (error) {
          console.error("Error fetching product data:", error);
          completeItems.push(item); // Use original item if fetch fails
        }
      }
    }

    this.setState({ completeCompareItems: completeItems, loading: false });
  };

    decodeHtmlEntities = (html) => {
    if (!html || typeof html !== "string") return html;
    try {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    } catch (e) {
      return html;
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadAddToCartMessageAnimation = (message) => {
    this.setState({
      showAddToCartMessageModal: true,
      addToCartMessage: message,
    });
  };

  getPropertyRows = () => {
    // Normalize incoming item shape: some endpoints return { product: {...} } while
    // others return the product object directly. Use `prod` in renderers.
    return [
      {
        label: getValueFromLanguageObject("str_image") || "Image",
        render: (item, symbol, masterDetailsObj) => {
          const prod = item && item.product ? item.product : item;
          const hasMedia = prod && prod.productmedia && prod.productmedia.length > 0;
          const imageUrl = hasMedia
            ? getImageUrl(prod.productmedia[0].productname, masterDetailsObj)
            : getPlaceHolderImage();

          return (
            <div className="w-100" style={{ maxWidth: "200px", position: 'relative', paddingTop: '100px' }}>
              <img
                src={imageUrl}
                alt={prod.name || prod.productname || "product"}
                className="w-100 h-100 position-absolute"
                style={{ objectFit: "cover", left: 0, top: 0 }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = getPlaceHolderImage();
                }}
              />
            </div>
          );
        },
      },
      {
        label: getValueFromLanguageObject("str_product") || "Product",
        render: (item) => {
          const prod = item && item.product ? item.product : item;
          return prod.name || prod.productname || "-";
        },
      },
      {
        label: getValueFromLanguageObject("str_price") || "Price",
        render: (item, symbol) => {
          const prod = item && item.product ? item.product : item;
          return (formatPrice(prod.price) + " " + (symbol || "")) || "-";
        },
      },
  {
  label: getValueFromLanguageObject("str_description") || "Description",
  render: (item) => {
    const prod = item && item.product ? item.product : item;
    return (
      <>
        <style>{`
          .description-content {
            white-space: normal !important;
            display: block !important;
            font-size: 14px;
            line-height: 1.6;
            color: #333;
            text-align: left;
          }

          /* remove empty junk */
          .description-content p:empty,
          .description-content div:empty {
            display: none;
          }

          /* headings */
          .description-content b,
          .description-content strong {
            display: block;
            margin: 12px 0 6px;
            font-weight: 600;
          }

          /* lists */
          .description-content ul,
          .description-content ol {
            margin: 8px 0 8px 18px !important;
            padding-left: 18px !important;
            list-style-position: outside !important;
          }

          .description-content li {
            margin-bottom: 6px;
          }

          /* images */
          .description-content img {
            display: block;
            margin: 10px auto;
            max-width: 100%;
            height: auto;
          }
        `}</style>

        <div
          className="description-content"
           dangerouslySetInnerHTML={{
                    __html: this.decodeHtmlEntities(prod.description),
                  }}
        />
      </>
    );
  },
},
      {
        label: getValueFromLanguageObject("str_availability") || "Availability",
        render: (item) => {
          const prod = item && item.product ? item.product : item;
          const qty = prod && typeof prod.availablequantity !== 'undefined' ? prod.availablequantity : 0;
          return qty > 0
            ? getValueFromLanguageObject("str_in_stock") || "In Stock"
            : getValueFromLanguageObject("str_out_of_stock") || "Out of Stock";
        },
      },
      {
        label: getValueFromLanguageObject("str_summary") || "Summary",
        render: (item) => {
          const prod = item && item.product ? item.product : item;
          let details = [];
          try {
            details = prod && prod.productdetails ? JSON.parse(prod.productdetails) : [];
          } catch (e) {
            details = [];
          }
          if (!details || !Array.isArray(details) || details.length === 0) return "-";

          return (
            <ul style={{ paddingLeft: 16, margin: 0 }}>
              {details.map((d, idx) => (
                <li key={idx}>
                  <strong>{d.lable}:</strong> {d.data}
                </li>
              ))}
            </ul>
          );
        },
      },
    ];
  };

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        return;
      }
      this.setState({ headerCounters: response });
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {}
  };

  addToCart = async (product, qty = 1, isInquiry = false) => {
    if (qty === "") return;
    const { counter, updateQuantity } = this.props;
    try {
      const currentPath = getCurrentPath(this.props);
      if (!checkAuthAndRedirect(this.props, currentPath)) return;

      let userDetails = loadUserDetailsFromLocalStorage();
      if (!isOpenStoreIdExist() && userDetails === undefined) return;
      userDetails = userDetails === undefined ? {} : userDetails;
      const { id, cityId } = userDetails;
      const openStoreId = window.getOpenStoreIdApp
        ? window.getOpenStoreIdApp()
        : undefined;
      let userId = openStoreId ? openStoreId : id;

      const addtocartUrl = isInquiry
        ? "orders/productInquiry"
        : "orders/addtocart";
      let addtocartObj = {
        orderstatus: 1,
        inshoppingcart: 1,
        userId,
        totalamount: isInquiry ? 0 : product.price * qty,
        orderdetails: [{ quantity: qty, productId: product.id }],
        cityId: cityId,
        date: new Date(),
      };

      const addToCartResponse = await postCall(addtocartUrl, addtocartObj);

      if (addToCartResponse.error) {
        clearLocalStorageReload({ response: addToCartResponse });
        this.loadErrorMessageAnimation(addToCartResponse.error.message);
        if (addToCartResponse.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else if (
        addToCartResponse.message &&
        (
          addToCartResponse.message === "Sorry! Product is out of stock" ||
          addToCartResponse.message === "Sorry! Product is not availble as per given quantity"
        )
      ) {
        // Handle out of stock or insufficient quantity message
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_out_of_stock") ||
          addToCartResponse.message ||
          "Sorry! Product is out of stock"
        );
        return;
      } else {
        this.loadAddToCartMessageAnimation(
          getValueFromLanguageObject("str_add_to_cart_successfully") ||
          "Product added to cart successfully"
        );

        setTimeout(async () => {
          await counter();
          updateQuantity();
          await this.fetchHeaderCounters();
        }, 500);
      }
    } catch (error) {
      // Handle error silently to avoid UI flicker
    }
  };

  fetchComparisonData = async () => {
    try {
      const response = await getCall("v2/product-comparisons", []);
      if (response && Array.isArray(response)) {
        this.setState({ completeCompareItems: response, loading: false });
      } else {
        console.error("Failed to fetch comparison data:", response);
        this.setState({ completeCompareItems: [], loading: false });
      }
    } catch (error) {
      console.error("Error fetching comparison data:", error);
      this.setState({ completeCompareItems: [], loading: false });
    }
  };

  removeFromCompare = async (comparisonId) => {
    if (!comparisonId) {
      console.error("Invalid comparison ID provided.");
      return;
    }

    try {
      const response = await deleteCall(
        `v2/product-comparisons/${comparisonId}`
      );
      if (response && response.success) {
        this.loadAddToCartMessageAnimation(
          getValueFromLanguageObject("str_remove_from_compare_successfully") ||
            "Product removed from comparison successfully"
        );
        this.fetchComparisonData();
        await this.fetchHeaderCounters(); // <-- Add this line
      } else {
        this.loadErrorMessageAnimation(
          response.message || "Failed to remove product from comparison."
        );
      }
    } catch (error) {
      this.loadErrorMessageAnimation(
        "An error occurred while removing the product from comparison."
      );
    }
  };

  render() {
    const { symbol, removeFromCompare } = this.props;
    const { completeCompareItems, masterDetailsObj, loading } = this.state;
    const compareItems = completeCompareItems;

    const colWidth =
      compareItems.length > 0 ? `${100 / compareItems.length}%` : "25%";

    // Dynamic button size based on the number of products
    const getButtonStyle = () => {
      const baseStyle = { fontSize: "14px" };
      switch (compareItems.length) {
        case 1:
          return { ...baseStyle, fontSize: "14px" };
        case 2:
          return { ...baseStyle, fontSize: "12px" };
        case 3:
          return { ...baseStyle, fontSize: "11px" };
        case 4:
          return { ...baseStyle, fontSize: "10px" };
        default:
          return { ...baseStyle, fontSize: "11px" };
      }
    };

    const buttonStyle = getButtonStyle();

    return (
      <div>
        <style>{buttonStyles}</style>
        <Breadcrumb
          title={getValueFromLanguageObject("str_compare") || "Compare"}
        />

        {loading ? (
          // Skeleton Loader
          <section className="compare-section section-b-space">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <table
                    className="table table-bordered text-left"
                    style={{ tableLayout: "fixed", width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "15%" }}>
                          {getValueFromLanguageObject("str_product_details") ||
                            "Product Details"}
                        </th>
                        {[...Array(3)].map((_, idx) => (
                          <th key={idx} style={{ width: "42.5%" }}>
                            <div className="skeleton-loader skeleton-text medium"></div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(6)].map((_, idx) => (
                        <tr key={idx}>
                          <td>
                            <div className="skeleton-loader skeleton-text short"></div>
                          </td>
                          {[...Array(3)].map((_, idx2) => (
                            <td key={idx2}>
                              <div className="skeleton-loader skeleton-text short"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        ) : compareItems.length > 0 ? (
          // Comparison Table
          <section className="compare-section section-b-space">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <table
                    className="table table-bordered text-left"
                    style={{ tableLayout: "fixed", width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "15%" }}>
                          {getValueFromLanguageObject("str_product_details") ||
                            "Product Details"}
                        </th>
                        {compareItems.map((item, idx) => (
                          <th key={item.id || idx} style={{ width: colWidth }}>
                            {item.product.name}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {this.getPropertyRows().map((row, i) => (
                        <tr key={i}>
                          <td>
                            <b>{row.label}</b>
                          </td>
                          {compareItems.map((item, idx) => (
                            <td
                              key={item.id || idx}
                              style={{ width: colWidth }}
                            >
                              {row.render(item, symbol, masterDetailsObj)}
                            </td>
                          ))}
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        {compareItems.map((item, idx) => (
                          <td key={item.id || idx} style={{ width: colWidth }}>
                            <div className="compare-btn-container d-flex flex-column gap-1">
                              <button
                                className="btn btn-solid btn-sm compare-dynamic-btn"
                                style={buttonStyle}
                                onClick={() => this.addToCart(item.product || item, 1)}
                              >
                                {getValueFromLanguageObject(
                                  "str_add_to_cart"
                                ) || "Add to Cart"}
                              </button>
                              <button
                                className="btn btn-danger btn-sm compare-dynamic-btn compare-remove-btn"
                                style={buttonStyle}
                                onClick={() => this.removeFromCompare(item.id)} // Call the updated method
                              >
                                {getValueFromLanguageObject("str_remove") ||
                                  "Remove"}
                              </button>
                            </div>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        ) : (
          // Empty State
          <section className="compare-empty-container">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="compare-empty-message">
                    <h3>
                      <strong>
                        {getValueFromLanguageObject(
                          "str_compare_list_is_empty"
                        ) || "Compare List is Empty"}
                      </strong>
                    </h3>
                    <h4>
                      {getValueFromLanguageObject(
                        "str_explore_more_shortlist_some_items"
                      ) || "Explore more shortlist some items."}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {this.state.showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={this.state.showErrorMessageModal}
            message={this.state.errorMessage}
            onClose={() => this.setState({ showErrorMessageModal: false })}
          />
        )}
        {this.state.showAddToCartMessageModal && (
          <AddToCartAnim
            show={this.state.showAddToCartMessageModal}
            message={this.state.addToCartMessage}
            onClose={() => this.setState({ showAddToCartMessageModal: false })}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  Items: state.compare.items,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps, {
  removeFromCompare,
  counter: getCommonCounter,
  updateQuantity: getUpdateQuantity,
  setHeaderCounters, // <-- add this
})(Compare);
